let personaVerificationSdk: () => Promise<unknown>;

export const setupPersona = (verify: () => Promise<unknown>) => {
  personaVerificationSdk = verify;
}

export const usePersona = () => {
    return personaVerificationSdk;
}